import { render, staticRenderFns } from "./tag-group.vue?vue&type=template&id=0d9f9248&scoped=true"
import script from "./tag-group.vue?vue&type=script&lang=js"
export * from "./tag-group.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d9f9248",
  null
  
)

export default component.exports